'use strict';
import register from './core';
import '../functions/jquery-global.js';
import Handlebars from 'handlebars/dist/handlebars';
import { isValidPhrase, keys } from '../functions/search-common';
import { getIsMobileDevice } from '../functions/common';

register('edu-search', function (element) {
  Handlebars.registerHelper('if_eq', function (a, b) {
    return a === b;
  });

  let $searchElement = $(element),
    currentLang = $('html').attr('lang'),
    $form = $('#search-form'),
    $levelfilters = $("#level-filters"),
    $tempofilters = $("#tempo-filters"),
    $languagefilters = $("#language-filters"),
    $sortOptions = $("#sort-options"),
    $eduType = $("#edu-type"),
    $occassionTermFilters = $("#occassion-term-filters"),
    $onlyShowFilter = $("#only-show-filter"),
    $searchCategoryFilter = $("#search-category-filter"),
    $searchContainer = $("#search-container"),
    filterTemplate = Handlebars.compile($('#template-category').html()),
    filterLanguageTemplate = Handlebars.compile($('#template-language').html()),
    filterTemplateRadio = Handlebars.compile($('#template-type').html()),
    filterTemplateTypeTabsRadio = Handlebars.compile($('#template-type-tabs').html()),
    $eduTypeTabs = $("#edu-type-tabs"),
    sortingTemplate = Handlebars.compile($('#template-sort-options').html()),
    templateResultDefault = Handlebars.compile($("#template-result-default").html()),
    areaofInterest = $('#template-interest-area').html(),
    resultTemplate = $('#template-result').html(),
    resultTemplatePartial = $('#template-result-partial').html(),
    $resetButton = $("button.reset-filter"),
    $interestArea = $("#interest-area"),
    $showMoreFilterButton = $("#show-more-btn"),
    $loadMoreResults = $('#load-more-results'),
    moreText = $searchElement.attr('data-more-text'),
    lessText = $searchElement.attr('data-less-text');
  var pagingNumber = 1;
  var loading = false;
  var filterHits = [];
  var loadedHits = 0;
  var isMobile = getIsMobileDevice();

  var types = {
    filters: [],
    current: ''
  };

  var courseCategoryId = $("#template-type").data("course-category-id");
  var coursePackageCategoryId = $("#template-type").data("course-package-category-id");

  var setSelectedFilter = function (searchQs) {
    var params = {};
    searchQs.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
      var temp = key.replace('r.', "");
      if (!params[temp]) {
        params[temp] = [];
      }
      params[temp].push(value);
    }
    );

    $.each(params, function (key, values) {
      $.each(values, function (index, value) {
        if (value && key.toString() != "GetAllHitsAccumulated") {
          var element = $searchElement.find('input[value="' + value.toString() + '"]');
          if (element.is(':checkbox') || element.is(':radio')) {
            element.prop('checked', true);
          }
          if (key.toString() == "Query") {
            var decodeValue = decodeURIComponent(value.replace(/\+/g, " "));
            $('#search-query').val(decodeValue);
          }
          if (key.toString() == "AreaOfInterest") {
            $searchElement.find("select").val(value);
          }
          if (key.toString() == "PagingNumber" && Number.isNaN(value)) {
            pagingNumber = parseInt(value);
          }
        }
      });
    });
  }
  // setup initial stuff, load category etc
  var init = function () {
    $.ajax({
      url: '/api/eduapi/areaofInterestfilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      let template = Handlebars.compile(areaofInterest);
      $interestArea.html(template({ Data: data, Name: 'areaofInterest' }));
    });
    $.ajax({
      url: '/api/eduapi/typefilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      types.filters = data;
      $eduType.html(filterTemplateRadio({ Data: data, Name: 'TypesFilters' }));
      $eduTypeTabs.html(filterTemplateTypeTabsRadio({ Data: data, Name: 'TypeTabs' }));
    });
    $.ajax({
      url: '/api/eduapi/levelfilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $levelfilters.html(filterTemplate({ Data: data, Name: 'LevelsFilters' }));
    });
    $.ajax({
      url: '/api/eduapi/occassiontermfilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $occassionTermFilters.html(filterTemplate({ Data: data, Name: 'OccassiontermFilters' }));
    });

    $.ajax({
      url: '/api/eduapi/tempofilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $tempofilters.html(filterTemplate({ Data: data, Name: 'TempoFilters' }));
    });

    $.ajax({
      url: '/api/eduapi/languagefilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $languagefilters.html(filterLanguageTemplate({ Data: data, Name: 'LanguagesFilters' }));
      if (data.length == 1) {
        $languagefilters.parent().css("visibility", "hidden");
      }
    });

    $.ajax({
      url: '/api/eduapi/limitationfilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $onlyShowFilter.html(filterTemplate({ Data: data, Name: 'LimitationsFilters' }));
    });
    $.ajax({
      url: '/api/eduapi/searchcategoryfilters',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $searchCategoryFilter.html(filterTemplate({ Data: data, Name: 'SearchCategoryFilters' }));
    });
    $.ajax({
      url: '/api/eduapi/sortingoptions',
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      $sortOptions.html(sortingTemplate({ Data: data, Name: 'SortingOptions' }));
      $("input:radio:first", $sortOptions).attr('checked', true);
    });

    Handlebars.registerPartial("templateResultPartial", resultTemplatePartial);
    if (isMobile) {
      $("#filter-groups .filter__group").hide().addClass('toggleable');
    }
  };
  var initSearch = function () {
    $searchContainer.html(templateResultDefault({ StatusSearching: true }));
    $loadMoreResults.hide();

    var execSearch = function (searchQs, preselectedfilters) {
      $.ajax({
        url: '/api/eduapi/search' + searchQs,
        headers: {
          'X-Language': currentLang
        }
      }).done(function (data) {
        loadedHits = data.Hits.length;
        if (data == null || loadedHits == 0) {
          $searchContainer.html(templateResultDefault({ StatusNoHits: true }));
        }
        else {
          let hitTemplate = Handlebars.compile(resultTemplate);
          $searchContainer.html(hitTemplate({ Hits: data.Hits, TotalCount: data.TotalHitsCount, Query: "" }));

          if (preselectedfilters) {
            for (var index in preselectedfilters) {
              var filter = preselectedfilters[index];
              var $input = $('input[value="' + filter.Key + '"]');
              if ($input) {
                $input.prop('checked', true);
                $input.attr("aria-checked", true);
              }
            }
          }
          const qsparams = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

          // Get the value of "PagingNumber" in querystring to set the correct number of loaded hits
          var qsPagingNumber = qsparams["r.PagingNumber"];
          var currentPagingNumber = Number.isNaN(qsPagingNumber) ? 1 : parseInt(qsPagingNumber);
          if (currentPagingNumber > 1) {
            pagingNumber = currentPagingNumber;
          }

          if (data.TotalHitsCount > loadedHits) {
            $loadMoreResults.show();
          }
        }
        setTimeout(filterHitsCount(data), 2000);
        setSelectedFilter(searchQs);
      });
    };

    var searchQs = window.location.search;
    if (!searchQs) {
      $.ajax({
        url: '/api/eduapi/preselectedfilters',
        headers: {
          'X-Language': currentLang
        }
      }).done(function (dataPredefined) {
        if (dataPredefined.length) {
          searchQs = '?';
          for (var index in dataPredefined) {
            var filter = dataPredefined[index];
            if (filter.Value === 'Types') {
              types.selected = filter.Key;
              searchQs += 'r.TypesSelected=' + types.selected + '&';
            }
            else {
              searchQs += 'r.' + filter.Value + '=' + filter.Key + '&';
            }
          }
        }
        execSearch(searchQs, dataPredefined);
      });
    }
    else {
      searchQs += '&r.GetAllHitsAccumulated=true';
      execSearch(searchQs, null);
    }
  }

  Handlebars.registerHelper('isdefined', function (value) {
    return value !== "";
  });

  var resetCurrentFilters = function () {
    event.preventDefault();
    window.history.replaceState(null, 'eduSearch', window.location.pathname);
    $("input:checkbox").prop('checked', false);
    $searchElement.find("select").val("");
    $('#search-query').val("");
    initSearch();
  };

  var updateResult = function (loadMore = false) {
    loading = true;
    $('[data-filter-button] input').prop("disabled", true);
    $loadMoreResults.hide();
    if (!loadMore) {
      pagingNumber = 1;
    }
    var currentValues = getCurrentValues();
    var queryString = $.param(currentValues, true)
    if (history.pushState)
      window.history.pushState(null, 'eduSearch', window.location.pathname + '?' + queryString);

    $.ajax({
      url: '/api/eduapi/search?' + queryString,
      headers: {
        'X-Language': currentLang
      }
    }).done(function (data) {
      var hitsCount = data.Hits.length;
      if (hitsCount == 0) {
        $searchContainer.html(templateResultDefault({ StatusNoHits: true }));
        filterHitsCount(data);
      }
      else if (loadMore) {
        var partialResult = Handlebars.compile(resultTemplatePartial);
        var newData = partialResult({ Hits: data.Hits });
        $($searchContainer).find("ul").append(newData);
        loadedHits += hitsCount;
      }
      else {
        let hitTemplate = Handlebars.compile(resultTemplate);
        $searchContainer.html(hitTemplate({ Hits: data.Hits, TotalCount: data.TotalHitsCount, Query: currentValues["r.Query"] }));
        filterHitsCount(data);
        loadedHits = hitsCount;
      }
      if (data.TotalHitsCount > loadedHits && hitsCount > 0) {
        $loadMoreResults.show();
      }
      $('[data-filter-button] input').removeAttr("disabled");
      loading = false;
    });
  }
  var getCurrentValues = function () {
    var edutimefiltersValues = $('input[name="LimitationsFilters"]:checked')
      .map(function () { return this.value; }).get();
    var searchCategoryfiltersValues = $('input[name="SearchCategoryFilters"]:checked')
      .map(function () { return this.value; }).get();
    var levelfiltersValues = $('input[name="LevelsFilters"]:checked')
      .map(function () { return this.value; }).get();
    var languageFiltersValues = $('input[name="LanguagesFilters"]:checked')
      .map(function () { return this.value; }).get();
    var tempoFiltersValues = $('input[name="TempoFilters"]:checked')
      .map(function () { return this.value; }).get();
    var OccassionTermValues = $('input[name="OccassiontermFilters"]:checked')
      .map(function () { return this.value; }).get();
    var SortOption = $('input[name="SortingOptions"]:checked')
      .map(function () { return this.value; }).get();
    var selectedInterestArea = !$searchElement.find("option:selected").val() ? [] : $searchElement.find("option:selected").val();
    var searchQueryValue = !$('#search-query').val() ? "" : $('#search-query').val();
    var typesFilterValues = $('input[name="TypesFilters"]:checked')
      .map(function () { return this.value; }).get();

    return {
      'r.PagingNumber': pagingNumber,
      'r.AreaOfInterest': selectedInterestArea,
      'r.Levels': levelfiltersValues,
      'r.Languages': languageFiltersValues,
      'r.Limitations': edutimefiltersValues,
      'r.SearchCategories': searchCategoryfiltersValues,
      'r.Tempo': tempoFiltersValues,
      'r.OccassionTerm': OccassionTermValues,
      'r.Query': searchQueryValue,
      'r.TypesSelected': typesFilterValues,
      'r.Sort': SortOption
    };
  };

  $showMoreFilterButton.on('click', function (event) {
    var opened = $(this).hasClass('less');
    $(this).find(".btn-text").text(opened ? moreText : lessText)
    $(this).toggleClass('less', !opened);
    if (opened) {
      $("html, body").animate({ scrollTop: 0 });
    }
    $searchElement.find("fieldset.toggleable").fadeToggle('toggleable');
  });

  $resetButton.on('click', function (event) {
    resetCurrentFilters()
  });

  $searchElement.on('change', 'select', function (e) {
    e.preventDefault();
    updateResult();
  });

  $loadMoreResults.on('click', function (e) {
    if (!loading && $loadMoreResults.is(":visible")) {
      $loadMoreResults.hide();
      e.preventDefault();
      e.stopImmediatePropagation();
      pagingNumber += 1;
      updateResult(true);
    }
  });

  $searchElement.on('click', '[data-filter-button]', function (e) {
    var $input = $(this).find('input')

    if ($($input).attr('name') == 'TypesFilters') {
      // in this special case we handle the TypesFilters (programme/course) that are also connected to the "tabs". 
      var $otherElement = $eduTypeTabs.find('input[value="' + $($input).attr('value') + '"]');
      $otherElement.trigger('click');
    }
    else {
      // this is the default case
      $($input).prop('checked', !$($input).prop('checked')).trigger('change');
      $($input).attr("aria-checked", $($input).prop('checked'));
      $($input).focus();
      updateResult();
    }
  });

  $eduTypeTabs.on('click', '[data-type-tabs-button]', function (e) {
    var $input = $(this).find('input');
    var value = $input.attr('value');
    var $otherInput = $eduTypeTabs.find('input[aria-checked="true"]');
    var $otherElement = $eduType.find('input[value="' + value + '"]');
    types.selected = value;
    if ($otherInput) {
      $($otherInput).attr("aria-checked", false);
    }
    $($input).prop('checked', true);
    $($input).attr("aria-checked", true);

    if ($otherElement) {
      $($otherElement).prop('checked', true);
      $($otherElement).attr("aria-checked", true);
      updateResult();
    }
  });
  $eduTypeTabs.on('keydown', '[data-type-tabs-button]', function (e) {
    if (e.keyCode == keys.enter || e.keyCode == keys.space) {
      var $input = $(this).find('input');
      $($input).prop('checked', true);
      $(this).trigger("click")
    }
  });
  $searchElement.on('click', '[data-sorting-button]', function (e) {
    if (e.target.type == 'radio') {
      var $input = $(this).find('input')
      $($input).focus();
      updateResult();
    }
  });
  $searchElement.on('keydown', '[data-sorting-button]', function (e) {
    if (e.keyCode == keys.enter || e.keyCode == keys.space) {
      e.target.type = 'radio'
      $(this).trigger("click")
    }
  });

  $searchElement.on('keydown', '[data-filter-button]', function (e) {
    if (e.keyCode == keys.enter || e.keyCode == keys.space) {
      e.stopImmediatePropagation();
      e.preventDefault();
      $(this).trigger("click")
    }
  });

  $('#search-query').on('keydown', function (e) {
    if (e.keyCode == keys.enter) {
      e.stopImmediatePropagation();
      e.preventDefault();
      $(this).trigger("submit")
    }
  });
  $form.on('submit', function (e) {
    e.preventDefault();
    var query = $('#search-query').val();
    if (!isValidPhrase(query))
      return false;
    updateResult();
  });

  // change filterHitsCount in the DOM
  var filterHitsCount = function (data) {
    filterHits = [];
    filterHits = filterHits.concat(data.EduTypeFilters);
    filterHits = filterHits.concat(data.EduAreaOfInterestFilters);
    filterHits = filterHits.concat(data.EduLanguageFilters);
    filterHits = filterHits.concat(data.EduLevelFilters);
    filterHits = filterHits.concat(data.EduLimitationFilters);
    filterHits = filterHits.concat(data.EduSearchCategoriesFilters);
    filterHits = filterHits.concat(data.EduOccassionTermFilters);
    filterHits = filterHits.concat(data.EduTempoFilters);

    $('[data-filter-button] .filter-count-text').text('0');
    $('[data-type-tabs-button] .tab-count-text').text('0');

    let countOfCoursePackagesHits;
    let totalCount;

    for (var index = 0; index < filterHits.length; index++) {
      var filter = filterHits[index];
      var $element = $('[data-count-name="' + filter.Key + '"]');
      var isCourse = false;

      var coursePackageExists = filterHits.find(filt => filt.Key === coursePackageCategoryId);
      if (coursePackageExists == undefined) {
        coursePackageExists = false;
      }

      if (filter.Key == courseCategoryId) {
        isCourse = true;
        if (coursePackageExists) {
          countOfCoursePackagesHits = filterHits.find(filt => filt.Key == coursePackageCategoryId).Count;
        } else {
          countOfCoursePackagesHits = 0;
        }      
        totalCount = filter.Count + countOfCoursePackagesHits;
      }

      if (filter.Key == coursePackageCategoryId) {
        $element = $('[data-count-name="' + courseCategoryId + '"]');

        var courseHitsFilter = filterHits.find(filt => filt.Key == courseCategoryId);
        if (courseHitsFilter != undefined) {
          totalCount = filter.Count + courseHitsFilter.Count;
          isCourse = true;
        }
      }

      if ($element) {
        if (isCourse) {
          $element.text(totalCount.toString());
        } else {
          $element.text(filter.Count);
        }
      }
    }
  };

  // infinity scroll load more
  $(window).scroll(function () {
    var scrollHeight = $(document).height();
    var scrollPos = $(window).height() + $(window).scrollTop();
    if (((scrollHeight - 300) >= scrollPos) / scrollHeight == 0) {
      $loadMoreResults.click();
    }
  });

  init();
  initSearch();
});
